import { Navigate, Route, Routes } from "react-router";
import { AuthProvider } from "./auth/AuthContext";
import { AuthGuard, GuestGuard } from "./auth/AuthGuard";
import { LoginPage } from "./features/auth/LoginPage";
import { AccountBlockedPage } from "./features/auth/AccountBlockedPage";
import { TodayPage } from "./features/today/TodayPage";
import { ScanPage } from "./features/scan/ScanPage";
import { HistoryPage } from "./features/history/HistoryPage";
import { StatsPage } from "./features/stats/StatsPage";

/**
 * Vague 1 · Phase C · App agent (PWA mobile-first).
 *
 * Routes :
 *  - `/login` public (guard "anonyme uniquement", retour à state.from
 *    après auth réussie)
 *  - `/` Ma journée (auth requise)
 *  - `/scan/:pointRondeId` atterrissage QR de point de ronde (auth requise,
 *    si anonyme → /login avec returnTo pour revenir scanner après auth)
 *
 * Pas d'AppShell desktop comme platform : chaque page gère son propre
 * layout mobile-friendly (sticky topbar, scroll plein écran).
 */
export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/login"
          element={
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          }
        />
        <Route path="/compte-bloque" element={<AccountBlockedPage />} />
        <Route
          path="/"
          element={
            <AuthGuard>
              <TodayPage />
            </AuthGuard>
          }
        />
        <Route
          path="/scan/:pointRondeId"
          element={
            <AuthGuard>
              <ScanPage />
            </AuthGuard>
          }
        />
        <Route
          path="/historique"
          element={
            <AuthGuard>
              <HistoryPage />
            </AuthGuard>
          }
        />
        <Route
          path="/stats"
          element={
            <AuthGuard>
              <StatsPage />
            </AuthGuard>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
